module.exports = __webpack_public_path__ + "static/img/bg1.55c0aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/bg1.png
// module id = 4sKV
// module chunks = 69